// extracted by mini-css-extract-plugin
export default {"prescription":"MedicationRequest_modal_prescription__6lbfR"};